import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import {store} from './configureStore';

ReactDOM.render(
  <App store={store}/>, document.getElementById('root'));

